import { Target, Eye } from "lucide-react";

function MissionVision() {
  return (
    <section
      className="py-24 bg-gradient-to-b from-blue-50 to-white"
      id="mission"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-16">

          <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold">
            Our Purpose
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-6">
            Mission &
            <span className="text-blue-700"> Vision</span>
          </h2>

          <p className="mt-5 text-gray-600 max-w-2xl mx-auto">
            We aim to empower learners with practical digital skills,
            preparing them for successful careers and future technologies.
          </p>

        </div>

        {/* Cards */}

        <div className="grid lg:grid-cols-2 gap-10">

          {/* Mission */}

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition duration-300 border border-blue-100 hover:-translate-y-2">

            <div className="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center mb-8">

              <Target className="text-blue-700" size={38} />

            </div>

            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Our Mission
            </h3>

            <p className="text-gray-600 leading-8 text-lg">
              To empower students with practical digital skills that create
              meaningful career opportunities and prepare them for the future
              of technology through industry-oriented learning.
            </p>

          </div>

          {/* Vision */}

          <div className="bg-blue-700 text-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition duration-300 hover:-translate-y-2">

            <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center mb-8">

              <Eye className="text-blue-700" size={38} />

            </div>

            <h3 className="text-3xl font-bold mb-6">
              Our Vision
            </h3>

            <p className="leading-8 text-lg text-blue-100">
              To become one of India's most trusted digital education
              institutes by delivering high-quality, practical, and
              innovation-driven learning experiences that transform careers.
            </p>

          </div>

        </div>

      </div>
    </section>
  );
}

export default MissionVision;